import { ReactNode } from "react";
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';

export interface AdminTileProps {
    title: string,
    description: string,
    onRefresh?: () => void | undefined | Promise<void>,
    variant: string,
    children?: ReactNode
}

export default function AdminTile({ title, description, onRefresh = undefined, variant, children }: AdminTileProps) {
    function getVariantClasses(variant: string) {
        switch (variant) {
            case "danger": return "bg-danger text-white";
            case "warning": return "bg-warning text-black";
            default: return null;
        }
    }

    return (
        <Card className="h-100">
            <Card.Header as="h5" className={getVariantClasses(variant) ?? "bg-white"}>
                <span className="d-flex">
                    {title}
                    {onRefresh &&
                        <Button variant="link" className={`${getVariantClasses(variant) ?? "text-black"} ms-auto`} onClick={onRefresh}>
                            <FontAwesomeIcon icon={faRefresh} />
                        </Button>
                    }
                </span>
            </Card.Header>
            <Card.Body className="d-flex flex-column">
                <Card.Subtitle>
                    {description}
                </Card.Subtitle>
                <div className="mt-2 flex-fill d-flex flex-column">
                    {children}
                </div>
            </Card.Body>
        </Card>
    );
}